import React, {useState, useEffect} from "react";
import {withStyles} from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import moment from "moment";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {KeyboardDatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import { FormControlLabel } from "@material-ui/core";

const styles = theme => ({
    container: {
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        paddingBottom: theme.spacing(1),
        alignItems: "center",
        justifyContent: "flex-start"
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        width: 225
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    formsContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start"
    }
});

const ClientTab = props => {
    const { classes, rent } = props;
    const [infiniteRent, setInfiniteRent] = useState(false);
    const options = props.clients.map(client => client.nazwa);
    options.unshift("");

    useEffect(() => {
        if(+rent.czas_do === 0) {
            setInfiniteRent(true);
        }
    }, [rent.czas_do]);

    useEffect(() => {
        if(infiniteRent)
            props.onRentChange('czas_do', 0);
    }, [infiniteRent])

    return (
        <div className={classes.formsContainer}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
                <form className={classes.container}>
                    <Autocomplete
                        id="selectedClientFieldId"
                        className={classes.textField}
                        options={options}
                        style={{width: 225, marginRight: 8}}
                        onChange={(event, value) => props.onSelectedClientChangeHandler(value)}
                        getOptionLabel={option => option}
                        renderInput={params => <TextField {...params} label="Wybierz Klienta"
                                                          value={props.selectedClient}/>}
                    />

                    <KeyboardDateTimePicker
                        className={classes.textField}
                        ampm={false}
                        name="czas_od"
                        value={moment.unix(rent.czas_od).format("YYYY-MM-DD HH:mm:ss")}
                        maxDate={infiniteRent ? null : moment.unix(rent.czas_do)}
                        onChange={(date) => props.onRentChange('czas_od', date)}
                        label="Od"
                        format="YYYY-MM-DD HH:mm:ss"
                    />
                    {!infiniteRent && <KeyboardDateTimePicker
                        className={classes.textField}
                        ampm={false}
                        name="czas_do"
                        value={moment.unix(rent.czas_do).format("YYYY-MM-DD HH:mm:ss")}
                        minDate={infiniteRent ? moment() : moment.unix(rent.czas_od)}
                        onChange={(date) => props.onRentChange('czas_do', date)}
                        label="do"
                        format="YYYY-MM-DD HH:mm:ss"
                        disabled={infiniteRent}
                    />}
                    <FormControl className={classes.textField}>
                        <FormControlLabel
                            label="Brak daty zakończenia"
                            control={
                                <Checkbox
                                    checked={infiniteRent}
                                    onChange={(e) => setInfiniteRent(e.target.checked)}
                                />
                            }
                        />
                    </FormControl>

                    <TextField
                        onChange={props.onRentChange}
                        label="Limit km"
                        className={classes.textField}
                        type="number"
                        name="limitkm"
                        value={rent.limitkm ? rent.limitkm : ""}
                    />
                    <FormControl className={classes.textField}>
                        <InputLabel>Limit:</InputLabel>
                        <Select
                            onChange={props.onRentChange}
                            value={rent.limitkm_rodzaj}
                            inputProps={{
                                name: "limitkm_rodzaj"
                            }}
                        >
                            <MenuItem value="0">Całkowity</MenuItem>
                            <MenuItem value="1">Dobowy</MenuItem>
                            <MenuItem value="2">Za dzień kalendarzowy</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField
                        onChange={props.onRentChange}
                        label="Nr rej auta w naprawie"
                        className={classes.textField}
                        value={rent.nr_rej_naprawa ? rent.nr_rej_naprawa : ""}
                        name="nr_rej_naprawa"
                    />
                    <TextField
                        onChange={props.onRentChange}
                        label="Stawka za km ponad limit"
                        className={classes.textField}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">PLN</InputAdornment>
                        }}
                        type="number"
                        value={rent.pool_st_pow_lim_km ? rent.pool_st_pow_lim_km : ""}
                        name="pool_st_pow_lim_km"
                    />
                    <TextField
                        onChange={props.onRentChange}
                        label="Ryczałt"
                        className={classes.textField}
                        type="number"
                        InputProps={{
                            endAdornment: <InputAdornment position="end">PLN</InputAdornment>
                        }}
                        value={rent.ryczalt ? rent.ryczalt : ""}
                        name="ryczalt"
                    />
                    <FormControl className={classes.textField}>
                        <InputLabel>Ryczałt za:</InputLabel>
                        <Select
                            onChange={props.onRentChange}
                            value={rent.ryczalt_rodzaj ? rent.ryczalt_rodzaj : ""}
                            inputProps={{
                                name: "ryczalt_rodzaj"
                            }}
                        >
                            <MenuItem value="0">Za całość</MenuItem>
                            <MenuItem value="1">Za godzinę</MenuItem>
                            <MenuItem value="2">Za dzień</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField
                        onChange={props.onRentChange}
                        id="service-number"
                        label="Numer zlecenia serwisowego"
                        className={classes.textField}
                        value={rent.nr_zlecenia_serwisowego ? rent.nr_zlecenia_serwisowego : ""}
                        name="nr_zlecenia_serwisowego"
                    />

                </form>

                <h3>Klient</h3>
                <form className={classes.container} id="client">
                    <TextField
                        id="name"
                        label="Imię i nazwisko/Nazwa firmy"
                        className={classes.textField}
                        value={rent.nazwa ? rent.nazwa : ""}
                        name="nazwa"
                        onChange={props.onRentChange}
                        required={true}
                        error={( !rent.nazwa && props.isError ) ? true : false}
                        helperText={( !rent.nazwa && props.isError ) ? "Pole wymagane" : null}
                    />

                    <FormControl className={classes.textField}>
                        <InputLabel>Rodzaj</InputLabel>
                        <Select
                            inputProps={{name: "klient_rodzaj"}}
                            onChange={props.onRentChange}
                            value={rent.klient_rodzaj ? rent.klient_rodzaj : ""}
                        >
                            <MenuItem value="">Nie określono</MenuItem>
                            <MenuItem value="Osoba prywatna">Osoba prywatna</MenuItem>
                            <MenuItem value="Firma">Firma</MenuItem>
                            <MenuItem value="Pracownik">Pracownik</MenuItem>
                        </Select>
                    </FormControl>

                    <TextField
                        name="ulica"
                        id="address"
                        label="Ulica i nr domu"
                        className={classes.textField}
                        value={rent.ulica ? rent.ulica : ""}
                        onChange={props.onRentChange}
                    />
                    <TextField
                        id="postcode"
                        label="Kod Pocztowy"
                        className={classes.textField}
                        value={rent.kod ? rent.kod : ""}
                        name="kod"
                        onChange={props.onRentChange}
                    />
                    <TextField
                        id="city"
                        label="Miejscowość "
                        className={classes.textField}
                        value={rent.miasto ? rent.miasto : ""}
                        onChange={props.onRentChange}
                        name="miasto"
                    />

                    <TextField
                        id="pesel"
                        label="Pesel / data urodzenia"
                        className={classes.textField}
                        value={rent.pesel ? rent.pesel : ""}
                        onChange={props.onRentChange}
                        name="pesel"
                    />
                    <TextField
                        id="clientId"
                        label="Seria i nr dowodu osobistego"
                        className={classes.textField}
                        name="dowod"
                        value={rent.dowod ? rent.dowod : ""}
                        onChange={props.onRentChange}
                    />
                    <TextField
                        value={rent.nip ? rent.nip : ""}
                        id="nip"
                        label="Nip"
                        className={classes.textField}
                        onChange={props.onRentChange}
                        name="nip"
                    />
                    <TextField
                        id="phone"
                        label="Telefon"
                        className={classes.textField}
                        value={rent.telefon ? rent.telefon : ""}
                        name="telefon"
                        onChange={props.onRentChange}
                    />
                    <TextField
                        id="email"
                        label="email"
                        className={classes.textField}
                        value={rent.email ? rent.email : ""}
                        onChange={props.onRentChange}
                        name="email"
                    />
                    <TextField
                        id="regon"
                        label="regon"
                        className={classes.textField}
                        value={rent.regon ? rent.regon : ""}
                        name="regon"
                        onChange={props.onRentChange}
                    />
                </form>
                <h3>Kierowca</h3>
                <form className={classes.container}>
                    <TextField
                        id="drivers-name"
                        label="Imię i nazwisko"
                        className={classes.textField}
                        value={!!rent.kierowca1_nazwa ? rent.kierowca1_nazwa : ""}
                        onChange={props.onRentChange}
                        name="kierowca1_nazwa"
                    />
                    <TextField
                        id="address"
                        label="Ulica i nr"
                        className={classes.textField}
                        value={rent.kierowca1_ulica ? rent.kierowca1_ulica : ""}
                        onChange={props.onRentChange}
                        name="kierowca1_ulica"
                    />
                    <TextField
                        id="postcode"
                        label="Kod pocztowy"
                        className={classes.textField}
                        value={rent.kierowca1_kod ? rent.kierowca1_kod : ""}
                        onChange={props.onRentChange}
                        name="kierowca1_kod"
                    />
                    <TextField
                        value={rent.kierowca1_miasto ? rent.kierowca1_miasto : ""}
                        id="city"
                        label="Miasto"
                        className={classes.textField}
                        onChange={props.onRentChange}
                        name="kierowca1_miasto"
                    />
                    <TextField
                        id="license-number"
                        label="Nr prawa jazdy "
                        className={classes.textField}
                        value={!!rent.kierowca1_prawo ? rent.kierowca1_prawo : ""}
                        name="kierowca1_prawo"
                        onChange={props.onRentChange}
                    />

                    <KeyboardDatePicker
                        id="driver1-license-issue-date"
                        ampm={false}
                        name="kierowca1_prawo_data"
                        value={rent.kierowca1_prawo_data
                            ? moment.unix(rent.kierowca1_prawo_data).format("YYYY-MM-DD")
                            : null}
                        onChange={(date) => props.onRentChange('kierowca1_prawo_data', date)}
                        label="Data wydania prawa jazdy"
                        format="YYYY-MM-DD"
                    />
                    <TextField
                        id="issued-by"
                        label="Organ wydający prawo jazdy"
                        className={classes.textField}
                        name="kierowca1_organ"
                        value={rent.kierowca1_organ ? rent.kierowca1_organ : ""}
                        onChange={props.onRentChange}
                    />
                    <TextField
                        id="pesel"
                        label="Pesel lub data urodzenia"
                        className={classes.textField}
                        value={rent.kierowca1_pesel ? rent.kierowca1_pesel : ""}
                        name="kierowca1_pesel"
                        onChange={props.onRentChange}
                    />
                    <TextField
                        id="phone"
                        label="Telefon"
                        className={classes.textField}
                        value={rent.kierowca1_telefon ? rent.kierowca1_telefon : ""}
                        onChange={props.onRentChange}
                        name="kierowca1_telefon"
                    />
                </form>
                <h3>Kierowca dodatkowy</h3>
                <form className={classes.container}>
                    <TextField
                        id="drivers-name"
                        label="Imię i nazwisko"
                        className={classes.textField}
                        value={rent.kierowca2_nazwa ? rent.kierowca2_nazwa : ""}
                        onChange={props.onRentChange}
                        name="kierowca2_nazwa"
                    />
                    <TextField
                        id="address"
                        label="Ulica i nr"
                        className={classes.textField}
                        value={rent.kierowca2_ulica ? rent.kierowca2_ulica : ""}
                        onChange={props.onRentChange}
                        name="kierowca2_ulica"
                    />
                    <TextField
                        id="postcode"
                        label="Kod pocztowy"
                        className={classes.textField}
                        value={rent.kierowca2_kod ? rent.kierowca2_kod : ""}
                        onChange={props.onRentChange}
                        name="kierowca2_kod"
                    />
                    <TextField
                        value={rent.kierowca2_miasto ? rent.kierowca2_miasto : ""}
                        id="city"
                        label="Miasto"
                        className={classes.textField}
                        onChange={props.onRentChange}
                        name="kierowca2_miasto"
                    />
                    <TextField
                        id="license-number"
                        label="Nr prawa jazdy "
                        className={classes.textField}
                        value={rent.kierowca2_prawo ? rent.kierowca2_prawo : ""}
                        name="kierowca2_prawo_nr"
                        onChange={props.onRentChange}
                    />

                    <KeyboardDatePicker
                        id="license-issue-date"
                        ampm={false}
                        name="czas_od"
                        value={rent.kierowca2_prawo_data
                            ? moment.unix(rent.kierowca2_prawo_data).format("YYYY-MM-DD")
                            : null}
                        onChange={(date) => props.onRentChange('kierowca2_prawo_data', date)}
                        label="Data wydania prawa jazdy"
                        format="YYYY-MM-DD"
                    />
                    <TextField
                        id="issued-by"
                        label="Organ wydający prawo jazdy"
                        className={classes.textField}
                        name="kierowca2_prawo_organ"
                        value={rent.kierowca2_organ ? rent.kierowca2_organ : ""}
                        onChange={props.onRentChange}
                    />
                    <TextField
                        id="pesel"
                        label="Pesel lub data urodzenia"
                        className={classes.textField}
                        value={rent.kierowca2_pesel ? rent.kierowca2_pesel : ""}
                        name="kierowca2_pesel"
                        onChange={props.onRentChange}
                    />
                    <TextField
                        id="phone"
                        label="Telefon"
                        className={classes.textField}
                        value={rent.kierowca2_telefon ? rent.kierowca2_telefon : ""}
                        onChange={props.onRentChange}
                        name="kierowca2_telefon"
                    />
                </form>
            </MuiPickersUtilsProvider>
        </div>
    );
};

export default withStyles(styles)(ClientTab);
